module.exports = __webpack_public_path__ + "static/media/wet_snow.70344486.svg";